import { defineStore } from 'pinia'

const useAuthStore = defineStore('auth', () => {
	const tokenCookie = useCookie('token')

	const user = ref(null)
	const token = computed(() => tokenCookie.value)

	const status = computed(() =>
		!!user.value ? 'authenticated' : 'unauthenticated'
	)

	const role = computed(() => user.value?.role)

	const login = async (credentials) => {
		try {
			const response = await apiFetch('/login', {
				method: 'POST',
				body: credentials
			})

			const { token: userToken, ...userData } = response

			user.value = userData
			tokenCookie.value = userToken

			return Promise.resolve(userData)
		} catch (error) {
			return Promise.reject(error)
		}
	}

	const fetchUser = async () => {
		if (!tokenCookie.value) {
			return
		}

		try {
			const response = await apiFetch('/user')

			user.value = response

			return Promise.resolve(response)
		} catch (error) {
			tokenCookie.value = null

			return Promise.reject(error)
		}
	}

	const logout = async () => {
		try {
			await apiFetch('/user/logout', {
				method: 'POST'
			})
		} catch (error) {
		} finally {
			tokenCookie.value = null
			user.value = null

			return Promise.resolve()
		}
	}

	const refresh = async () => {
		if (!tokenCookie.value) {
			return
		}

		try {
			const response = await apiFetch('/refresh-token', {
				method: 'POST'
			})

			const { token: userToken, ...userData } = response

			user.value = userData
			tokenCookie.value = userToken

			return Promise.resolve(userData)
		} catch (e) {
			tokenCookie.value = null

			return Promise.reject(e)
		}
	}

	return { login, logout, refresh, fetchUser, user, token, status, role }
})

export default useAuthStore
